import React from 'react';
import moment from 'moment';

function ConflictSaveModal(props) {
    const { isVisible, conflict, onClose } = props;

    if (!isVisible || !conflict) {
        return null;
    }

    const formattedTime = conflict.updatedAt ? moment(conflict.updatedAt).format('LT') : '';

    return (
        <div className='user_popup active'>
            {/* No overlay dismiss - blocking modal */}
            <span className="popup_overlay"></span>
            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                {/* No close button - blocking modal */}
                <div className="approve_popup_header text_center relative">
                    <p>
                        Conflict Detected: This record was modified by {conflict?.userName || 'another user'}
                        {formattedTime && ` at ${formattedTime}`}. Please exit edit mode without saving and re-open to include most recent changes before proceeding.
                    </p>
                </div>
                <div className="content">
                    <div className="field_row text_center">
                        {/* Only OK button - no save action */}
                        <button className="small_btn active" onClick={onClose}>OK</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConflictSaveModal;
